<template>
  <client-only>
    <cms-pop-up-manager />
  </client-only>

  <div
    v-if="isPreview && netlifyDeployContext === 'deploy-preview' && show"
    class="p-1 bg-red-60 flex gap-1 items-center left-0 top-0 fixed"
    style="z-index: 10002"
  >
    <span>PR preview: {{ previewId }}</span>
    <base-button aria-label="Hide PR preview ID" @click="show = false">
      <vf-icon name="close" size="sm" />
    </base-button>
  </div>
</template>

<script setup>
const { netlifyDeployContext, netlifyDeployUrl } = useRuntimeConfig().public
const { isPreview } = useCms()

const previewId = netlifyDeployUrl.match(/deploy-preview-(\d+)/)?.[1]

const show = ref(true)
</script>
